
export const GETTERS = {
    GET_CATALOG: 'GET_CATALOG',
    GET_APPLICATIONS: 'GET_APPLICATIONS',
    GET_CURRENT_TYPE: 'GET_CURRENT_TYPE',
    GET_SETPOINT: 'GET_SETPOINT',
    GET_ROUTE_PARAMS: 'GET_ROUTE_PARAMS',
    GET_CONSULT_ID: 'GET_CONSULT_ID',
    GET_LOADING: 'GET_LOADING',
    GET_MAIL_RESPONSE: 'GET_MAIL_RESPONSE',
    GET_STEPS: 'GET_STEPS',
    GET_CURRENT_STEP_INDEX: 'GET_CURRENT_STEP_INDEX',
    GET_MAX_STEP_INDEX: 'GET_MAX_STEP_INDEX',
    GET_CONSULT: 'GET_CONSULT',
    GET_VOLTAGE: 'GET_VOLTAGE',
    GET_VOLTAGE: 'GET_RMS_VOLTAGE',
    GET_AC_CURRENT: 'GET_AC_CURRENT',
    GET_DC_CURRENT: 'GET_DC_CURRENT',
    GET_AC_POWER: 'GET_AC_POWER',
    GET_DC_POWER: 'GET_DC_POWER',
    GET_FREQUENCY: 'GET_FREQUENCY',
    GET_PRODUCTS: 'GET_PRODUCTS',
};
export const MUTATIONS = {
    SET_CATALOG: 'SET_CATALOG',
    SET_UI: 'SET_UI',
    SET_CONSULT_ID: 'SET_CONSULT_ID',
    SET_LOADING_TO_TRUE: 'SET_LOADING_TO_TRUE',
    SET_LOADING_TO_FALSE: 'SET_LOADING_TO_FALSE',
    SET_MAIL_RESPONSE: 'SET_MAIL_RESPONSE',
    SET_CURRENT_STEP_INDEX: 'SET_CURRENT_STEP_INDEX',
    SET_MAX_STEP_INDEX: 'SET_MAX_STEP_INDEX',
    SET_CONSULT: 'SET_CONSULT',
    TOGGLE_CONSULT_APPLICATION: 'TOGGLE_CONSULT_APPLICATION',
    SET_PRODUCTS: 'SET_PRODUCTS',
    RESET_SPECS: 'RESET_SPECS',
    RESET_CONSULT: 'RESET_CONSULT'
};
export const ACTIONS = {
    RETRIEVE_CATALOG: 'RETRIEVE_CATALOG',
    SAVE_CONSULT: 'SAVE_CONSULT',
    SEND_EMAIL: 'SEND_EMAIL',
};
